import { useSyncExternalStore } from 'react'

/** Whether the browser tab is on screen: false while another tab or the lock screen covers it. */
export function usePageVisible(): boolean {
  return useSyncExternalStore(
    (onChange) => {
      document.addEventListener('visibilitychange', onChange)
      return () => {
        document.removeEventListener('visibilitychange', onChange)
      }
    },
    () => document.visibilityState !== 'hidden',
    () => true,
  )
}
